import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { UIOfferWhenWatchFaq } from 'interfaces/ui/ui-offer-when-watch-faq';
import { useRef, useState } from 'react';
import {
  StyledFaqs,
  StyledFaqsButton,
  StyledFaqsContent,
  StyledFaqsIcon,
  StyledFaqsQuestion,
  StyledFaqsText,
  StyledFaqsTitle
} from '../faqs/Faqs.styled';

const WhenWatchFaqs = ({
  watchFaqs,
  migratedToMarkdown
}: {
  migratedToMarkdown: boolean;
  watchFaqs: UIOfferWhenWatchFaq;
}) => {
  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0px');

  const content = useRef<HTMLElement>(null);

  function toggleAccordion(): void {
    setActiveState(setActive === '' ? 'is-active' : '');
    if (content !== null) {
      if (content.current !== null) {
        setHeightState(
          setActive === 'is-active'
            ? '0px'
            : `${content.current.scrollHeight}px`
        );
      }
    }
  }

  return (
    <StyledFaqs>
      <StyledFaqsQuestion>
        <StyledFaqsButton className={`${setActive}`} onClick={toggleAccordion}>
          <StyledFaqsTitle>{watchFaqs.q}</StyledFaqsTitle>
          <StyledFaqsIcon>
            <FontAwesomeIcon icon={faCaretDown} />
          </StyledFaqsIcon>
        </StyledFaqsButton>
      </StyledFaqsQuestion>

      <StyledFaqsContent ref={content} style={{ maxHeight: `${setHeight}` }}>
        <StyledFaqsText>
          {migratedToMarkdown ? (
            <MarkdownComponent content={watchFaqs.a || ''} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: watchFaqs.a || '' }}></div>
          )}
        </StyledFaqsText>
      </StyledFaqsContent>
    </StyledFaqs>
  );
};

export default WhenWatchFaqs;
